import i18n from 'i18next';

import { registerValidator } from 'core/forms';

const isPasswordMatch = ({ fieldValue, validator: { isRequired } = {}, model }) => {
  const isEmpty = fieldValue == null || fieldValue === '';

  if (isEmpty) {
    return {
      hasError: isRequired,
      error: i18n.t('error-required-field'),
      isRequired,
    };
  }

  const passwordsMatch = fieldValue === model?.password;

  return {
    hasError: !passwordsMatch,
    error: i18n.t('error-passwords-do-not-match'),
    isRequired,
  };
};

registerValidator('isPasswordMatch', isPasswordMatch);

export default isPasswordMatch;
